(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    /* Safari fix: <details> with overridden display doesn't shrink-wrap.
     Pin the details element width to its summary's rendered width. */
  (function() {
    function fixFilterWidth() {
      document.querySelectorAll('.rotation-collection-header .mobile-facets__disclosure').forEach(function(details) {
        var summary = details.querySelector('summary');
        if (!summary) return;
        details.style.width = '';
        var w = summary.getBoundingClientRect().width;
        if (w > 0) details.style.width = w + 'px';
      });
    }

    function init() {
      fixFilterWidth();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.classList.contains('mobile-facets__disclosure') || node.querySelector && node.querySelector('.mobile-facets__disclosure'))) {
            fixFilterWidth();
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rot-per-page-dropdown"] && !Shopify.designMode) return;
  try {
    (function() {
    function buildTargetUrl(value) {
      var url = new URL(window.location.href);
      // 20 is the default — clear ?view= so URL stays clean.
      // 50/100 route to alternate templates via ?view=show-N.
      if (value === '20' || value === 20) {
        url.searchParams.delete('view');
      } else {
        url.searchParams.set('view', 'show-' + value);
      }
      // Reset to page 1 — staying on page 5 of 20 when switching to 100
      // per page would overshoot or land on an irrelevant page.
      url.searchParams.delete('page');
      return url.toString();
    }

    function initDropdown(dropdown) {
      if (dropdown.dataset.rotPerPageInit) return;
      dropdown.dataset.rotPerPageInit = '1';

      var trigger = dropdown.querySelector('.rot-per-page-dropdown__trigger');
      var list = dropdown.querySelector('.rot-per-page-dropdown__list');

      function close() {
        dropdown.removeAttribute('data-open');
        trigger.setAttribute('aria-expanded', 'false');
      }

      function open() {
        dropdown.setAttribute('data-open', '');
        trigger.setAttribute('aria-expanded', 'true');
      }

      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = dropdown.hasAttribute('data-open');
        // Close any other open per-page dropdowns
        document.querySelectorAll('.rot-per-page-dropdown[data-open]').forEach(function(d) {
          d.removeAttribute('data-open');
          d.querySelector('.rot-per-page-dropdown__trigger').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) open();
      });

      list.querySelectorAll('.rot-per-page-dropdown__option').forEach(function(option) {
        option.addEventListener('click', function() {
          var value = option.dataset.value;
          window.location.href = buildTargetUrl(value);
        });
      });

      // Close on outside click
      document.addEventListener('click', function(e) {
        if (!dropdown.contains(e.target)) close();
      });
    }

    function initAll() {
      document.querySelectorAll('.rot-per-page-dropdown').forEach(initDropdown);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rot-sort-dropdown"] && !Shopify.designMode) return;
  try {
    (function() {
    function initSortDropdown(dropdown) {
      var trigger = dropdown.querySelector('.rot-sort-dropdown__trigger');
      var list = dropdown.querySelector('.rot-sort-dropdown__list');
      var native = dropdown.querySelector('.rot-sort-dropdown__native');
      var current = dropdown.querySelector('.rot-sort-dropdown__current');
      var isToolbar = dropdown.classList.contains('rot-sort-dropdown--toolbar');

      // For toolbar variant: position the list via JS relative to viewport.
      // This bypasses any containing-block issues caused by positioned ancestors.
      function positionList() {
        if (!isToolbar) return;
        var rect = trigger.getBoundingClientRect();
        list.style.top = (rect.bottom + 4) + 'px';
        list.style.left = rect.left + 'px';
        list.style.width = rect.width + 'px';
      }

      function openDropdown() {
        dropdown.setAttribute('data-open', '');
        trigger.setAttribute('aria-expanded', 'true');
        positionList();
        if (isToolbar) {
          window.addEventListener('scroll', positionList, true);
          window.addEventListener('resize', positionList);
        }
      }

      function closeDropdown() {
        dropdown.removeAttribute('data-open');
        trigger.setAttribute('aria-expanded', 'false');
        if (isToolbar) {
          window.removeEventListener('scroll', positionList, true);
          window.removeEventListener('resize', positionList);
        }
      }

      // Catch any click inside the wrapper at capture phase so it doesn't bubble
      // up to a parent <details>/<summary> or form submit handler (closes the
      // mobile filter drawer on iOS Safari otherwise).
      dropdown.addEventListener('click', function(e) {
        e.stopPropagation();
      });

      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = dropdown.hasAttribute('data-open');
        // Close all open dropdowns
        document.querySelectorAll('.rot-sort-dropdown[data-open]').forEach(function(d) {
          d.removeAttribute('data-open');
          d.querySelector('.rot-sort-dropdown__trigger').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          openDropdown();
        }
      });

      // If we're rendered inside the mobile Filter & Sort drawer, the user
      // explicitly applies their selection via the drawer's "Apply" button.
      // Don't auto-submit on each option click — just store the value.
      var isInMobileDrawer = !!dropdown.closest('#FacetFiltersFormMobile');

      list.querySelectorAll('.rot-sort-dropdown__option').forEach(function(option) {
        option.addEventListener('click', function() {
          var value = option.dataset.value;

          // Update native select value
          native.value = value;

          // Update displayed label
          current.textContent = option.textContent.trim();

          // Update active states
          list.querySelectorAll('.rot-sort-dropdown__option').forEach(function(o) {
            var active = o === option;
            o.classList.toggle('is-selected', active);
            o.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          // Close dropdown
          closeDropdown();

          // Trigger facets.js via input event on the native select —
          // skipped inside the mobile drawer (Apply button handles submission).
          if (!isInMobileDrawer) {
            native.dispatchEvent(new Event('input', { bubbles: true }));
          }
        });
      });

      // Close on outside click
      document.addEventListener('click', function(e) {
        if (!dropdown.contains(e.target)) {
          closeDropdown();
        }
      });
    }

    function initAll() {
      document.querySelectorAll('.rot-sort-dropdown').forEach(function(dropdown) {
        if (!dropdown.dataset.rotSortInit) {
          dropdown.dataset.rotSortInit = '1';
          initSortDropdown(dropdown);
        }
      });
    }

    // Init on load
    initAll();

    // Re-init after facets AJAX updates
    document.addEventListener('shopify:section:load', initAll);

    // Also re-init when facets.js re-renders the sorting area
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            var dropdowns = node.querySelectorAll ? node.querySelectorAll('.rot-sort-dropdown:not([data-rot-sort-init])') : [];
            dropdowns.forEach(function(d) {
              if (!d.dataset.rotSortInit) {
                d.dataset.rotSortInit = '1';
                initSortDropdown(d);
              }
            });
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
